import React from "react";
import { ResponsiveDrawer } from "./ResponsiveDrawer";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Switch, Route } from "react-router-dom";
import { MenuItemProp, ShellProps } from "../ModuleProps";
import { AppBar } from "./AppBar";
import { Menu } from "./Menu";
import { CCEALink } from "./CCEALink";
import { useSelector } from "react-redux";
import { experimentalFeatureCheck } from "./experimentalFeatureHelper";

// this layout is taken from https://material-ui.com/components/drawers/#responsive-drawer
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contentHeightShim: {
      paddingTop: theme.contentOffsets.AFTER_MAIN_APPBAR,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      maxWidth: theme.breakpoints.values.xl,
    },
    menuSection: {
      overflowY: "auto",
      overflowX: "hidden",
      display: "flex",
      marginBottom: 115,
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      /* Track */
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 5px #293445",
        borderRadius: "10px",
      },
      /* Handle */
      "&::-webkit-scrollbar-thumb": {
        background: "#969696",
        borderRadius: "10px",
        borderRight: "1px #293445 solid",
      },
      /* Handle on hover */
      "&::-webkit-scrollbar-thumb:hover": {
        background: "grey",
      },
    },
    userDetailsMenuSection: {
      marginBottom: 15,
      paddingBottom: 15,
      borderBottom: "1px solid #ffffff1f",
    },
  })
);

export const Layout: React.FC<ShellProps> = ({
  userDetails: UserDetails,
  items = [],
  toolbarItems = [],
  coreItems = [],
}) => {
  const classes = useStyles();
  const [isMobileOpen, setIsMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const user = useSelector((state: any) => state.auth.user);

  return (
    <div className={`${classes.root} Root`}>
      <AppBar
        handleDrawerToggle={handleDrawerToggle}
        toolbarItems={toolbarItems}
      ></AppBar>

      <ResponsiveDrawer
        isMobileOpen={isMobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      >
        <React.Fragment>
          <div className={classes.userDetailsMenuSection}>
            <UserDetails />
          </div>
          <div className={classes.menuSection}>
            <Menu items={items} />
          </div>
          <CCEALink />
        </React.Fragment>
      </ResponsiveDrawer>

      <main className={classes.content}>
        <div className={classes.contentHeightShim} />
        <Switch>
          {items.map((item) => {
            return (
              item &&
              item.module &&
              shouldRenderRoute(item, user) && (
                <Route
                  key={item.pathOrUrl}
                  path={item.pathOrUrl}
                  exact={!!item.exactPathMatch}
                >
                  <item.module.component />
                </Route>
              )
            );
          })}
        </Switch>
      </main>
    </div>
  );
};

const shouldRenderRoute = (item: MenuItemProp, user: any): boolean => {
  const isVisible = !!(
    item.visibility(user) ||
    (!item.visibility(user) &&
      item.loadWhenInvisible &&
      item.loadWhenInvisible(user))
  );

  const experimentalFeatureVisible = item.experimentalFeatureVisibleName
    ? experimentalFeatureCheck(user, item.experimentalFeatureVisibleName)
    : true;

  const experimentalFeatureHidden = item.experimentalFeatureHiddenName
    ? experimentalFeatureCheck(user, item.experimentalFeatureHiddenName)
    : false;

  return isVisible && experimentalFeatureVisible && !experimentalFeatureHidden;
};
